import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagCF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#0052B4",
  d: "M46.96 13.044C43.73 7.124 38.175 2.654 31.522.861l-1.087 12.183H46.96ZM3.04 13.044h16.525L18.478.861C11.825 2.654 6.27 7.123 3.04 13.044Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M30.435 25v11.956H46.96A24.887 24.887 0 0 0 50 25H30.435ZM19.565 25H0c0 4.33 1.102 8.404 3.04 11.956h16.525V25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M3.04 36.957c3.23 5.921 8.785 10.39 15.438 12.184l1.087-10.655L3.04 36.957ZM31.522 49.14c6.653-1.792 12.208-6.262 15.438-12.183l-16.525 1.529 1.087 10.655ZM30.435 38.486l16.525-1.529H30.435v1.529Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "M19.565 36.957H3.04l16.525 1.529v-1.529Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0c-2.256 0-4.442.3-6.521.861v48.277c2.079.56 4.265.862 6.521.862 2.257 0 4.442-.301 6.522-.862V.861A25.027 25.027 0 0 0 25 0Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#FFDA44",
  d: "m13.447 5.434.675 2.076h2.183l-1.766 1.283.674 2.076-1.766-1.283-1.766 1.283.675-2.076L10.59 7.51h2.183l.674-2.076Z"
}));
FlagCF.displayName = 'FlagCF';
export default withFlagWrapper(FlagCF);
//# sourceMappingURL=index.js.map